var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleStars4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "109px",
    height: "18px",
    viewBox: "0 0 109 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6A303511-0CFA-40AA-8946-E4CC4F06E481") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02-3_\\uC81C\\uD488",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-3_Phase2.5_\\uBE14\\uB80C\\uB529\\uC0F4\\uD478_\\uC804\\uC81C\\uD488_\\uB9AC\\uBDF0-\\uC218\\uC815_MO",
    transform: "translate(-17.000000, -7380.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(17.000000, 7380.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Star-Copy-24",
    fill: "#6435C7",
    points: "31.7417582 13.5 26.4613797 16.2811529 27.4698423 10.3905765 23.1979264 6.21884705 29.101569 5.35942353 31.7417582 0 34.3819475 5.35942353 40.2855901 6.21884705 36.0136742 10.3905765 37.0221367 16.2811529"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-Copy-23",
    fill: "#6435C7",
    points: "8.98351648 13.5 3.70313798 16.2811529 4.71160054 10.3905765 0.439684593 6.21884705 6.34332723 5.35942353 8.98351648 0 11.6237057 5.35942353 17.5273484 6.21884705 13.2554324 10.3905765 14.263895 16.2811529"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-Copy-26",
    fill: "#6435C7",
    points: "76.0604396 13.5 70.7800611 16.2811529 71.7885236 10.3905765 67.5166077 6.21884705 73.4202503 5.35942353 76.0604396 0 78.7006288 5.35942353 84.6042715 6.21884705 80.3323555 10.3905765 81.3408181 16.2811529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.016484,0.565721495 L102.490523,5.5878714 L108.023772,6.39337484 L104.019839,10.3034066 L104.96492,15.8237644 L100.016484,13.2174438 L95.0680468,15.8237644 L96.0131282,10.3034066 L92.0091948,6.39337484 L97.5424439,5.5878714 L100.016484,0.565721495 Z",
    id: "Star-Copy-27",
    stroke: "#6435C7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-Copy-25",
    fill: "#6435C7",
    points: "54.5 13.5 49.2196215 16.2811529 50.2280841 10.3905765 45.9561681 6.21884705 51.8598107 5.35942353 54.5 0 57.1401893 5.35942353 63.0438319 6.21884705 58.7719159 10.3905765 59.7803785 16.2811529"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleStars4);
export default __webpack_public_path__ + "static/media/purpleStars4.c50d7fd1.svg";
export { ForwardRef as ReactComponent };